import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SearchableSelect } from "@/components/SearchableSelect";
import { APPLICATION_STATUS_LABELS } from "@/components/StatusPill";
import type { EquipmentNeedsItem } from "@/features/equipment/api/equipment.api";

export function ApplicationPicker({
  options,
  busy,
  onPick,
  onClose,
}: {
  options: EquipmentNeedsItem[];
  busy: boolean;
  onPick: (applicationId: string) => void;
  onClose: () => void;
}) {
  const [value, setValue] = useState("");
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New equipment order</DialogTitle>
          <DialogDescription>Which application is this for? The order is linked to it.</DialogDescription>
        </DialogHeader>
        {options.length === 0 ? (
          <p className="text-sm text-muted-foreground">Every application already has its equipment sorted.</p>
        ) : (
          <SearchableSelect
            value={value}
            onValueChange={setValue}
            placeholder="Pick an application…"
            searchPlaceholder="Search business name"
            options={options.map((o) => ({
              value: o.applicationId,
              label: o.applicationDba || "Unnamed business",
              hint: [APPLICATION_STATUS_LABELS[o.applicationStatus] ?? o.applicationStatus, o.agentName].filter(Boolean).join(" · "),
            }))}
          />
        )}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button disabled={!value || busy} onClick={() => onPick(value)}>Start order</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
